var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C7.89543 11 7 11.8954 7 13V22H10V19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19V22H17V13C17 11.8954 16.1046 11 15 11H9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.32439C2 4.89812 2.25857 4.51657 2.64888 4.36689L8.64888 2.06604C9.30263 1.81534 10 2.30954 10 3.02353V9.21746H9C7.067 9.21746 5.5 10.8199 5.5 12.7966V22H4C2.89543 22 2 21.0843 2 19.9548V5.32439Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.21746H15C16.933 9.21746 18.5 10.8199 18.5 12.7966V22H20C21.1046 22 22 21.0843 22 19.9548V5.32439C22 4.89812 21.7414 4.51657 21.3511 4.36689L15.3511 2.06604C14.6974 1.81534 14 2.30954 14 3.02353V9.21746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt4);
export default __webpack_public_path__ + "static/media/apartments-alt-4.1d62588d23ff61bc8ad7d41e285196b8.svg";
export { ForwardRef as ReactComponent };